import { KeyValueModel } from "./key-value-model";

export class FilterProp {
    Name: string;
    Value: string;
    Type: string;
    IsSelected: boolean;
    SkipOprs: string[];
    Common: boolean;
    ExValueOpts: KeyValueModel[];
    
    constructor(name: string = "", value: string = "", type: string = "", skipOprs: string[] = [], common: boolean = false, exValueOpts: KeyValueModel[] = []) {
      this.Name = name;
      this.Value = value;
      this.Type = type;
      this.IsSelected = false;
      this.SkipOprs = skipOprs;
      this.Common = common;
      this.ExValueOpts = exValueOpts;
    }
  }
  